import type { IV1ParsedData } from "./v1";

interface IBarData {
    chartData: {
        statement: string;
        value: number;
        date: number;
    }[];
    fixed: boolean;
    questions: string[];
    dates: number[];
    summaryStat: "avg" | "net";
}

interface ILinesData {
    fixed: boolean;
    chartData: {
        label: number;
        value: number;
    }[][][];
    lines: {
        statement: string;
        lineType: "avg" | "spread" | "net";
        label: boolean;
    }[];
    labels: number[];
}

interface ISpreadData {
    chartData: Record<string, number>[];
    questions: string[];
    areaHeight: number;
    showLabels: boolean;
}

interface IAnswerData {
    chartData: {
        statement: string;
        value: number;
        leftLabel: string;
        rightLabel: string;
    }[];
}

export type V2ChartDatum =
    | { chart: "lines"; data: ILinesData; heading: string }
    | { chart: "bar"; data: IBarData; heading: string }
    | { chart: "spread"; data: ISpreadData; heading: string }
    | { chart: "answer"; data: IAnswerData; heading: string };

export interface IV2ParsedData {
    charts: V2ChartDatum[];
    version: 2;
    title: string;
}

export function v1tov2(v1Data: IV1ParsedData): IV2ParsedData {
    return {
        title: v1Data.title,
        version: 2,
        charts: v1Data.charts.map((chartDatum) => {
            if (chartDatum.chart === "spread") {
                return {
                    chart: "spread",
                    heading: chartDatum.heading,
                    data: {
                        ...chartDatum.data,
                        showLabels: false,
                    },
                } as V2ChartDatum;
            }
            return chartDatum as unknown as V2ChartDatum;
        }),
    };
}
